// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
exports.push([module.id, ".accent-icon[data-v-50ff7709]{font-size:7rem;position:absolute;top:0;left:.5rem;transform:rotate(-20deg);opacity:.35}.rotate-180[data-v-50ff7709]{transform:rotate(180deg)}.willTransform[data-v-50ff7709]{transition:transform .25s ease-in-out}.scroller[data-v-50ff7709]{overflow:auto;margin-bottom:50px;height:600px}", ""]);
// Exports
module.exports = exports;
